import { Pipe, PipeTransform } from "@angular/core";
import { Params } from "@angular/router";

@Pipe({
  name: "queryParamsBuilder",
})
export class QueryParamsBuilderPipe implements PipeTransform {
  transform(queryParams: Params) {
    return queryParams;
  }
}
